
export default class Uri {

    constructor(from) {
        this.reset(from ?? window.location);
    }

    reset(from) {
        if (typeof from === 'string' && from.indexOf('http') !== 0) {
            from = window.App.base + from;
        }

        let urlObject = new URL(from);
        this.decode = {
            '%5B': '[',
            '%5D': ']',
            '%2C': ',',
        };
        this.path = urlObject.pathname;
        this.query = new URLSearchParams(urlObject.search);

        return this;
    }

    setPath(path) {
        this.path = path;
        return this;
    }

    hasQuery(key, value) {
        if (! this.query.has(key)) {
            return false;
        }

        if (value === undefined) {
            return true;
        }

        return this.query.get(key) === value;
    }

    getQuery(key) {
        return this.query.get(key);
    }

    addQuery(key, value) {
        this.removeQuery(key);
        this.query.append(key, value);
        return this;
    }

    removeQuery(key) {
        this.query.delete(key);
        return this;
    }

    toString() {
        let queryString = this.query.toString();
        Object.entries(this.decode).forEach(([encoded, decoded]) => {
            queryString = queryString.replaceAll(encoded, decoded);
        });

        return queryString
            ? this.path + '?' + queryString
            : this.path
    }

    redirect() {
        return window.location.replace(this.toString());
    }
}
